export default {"src":"/_next/static/media/office-hours.9b207ef9.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};